import * as React from "react";
import { ContentProps } from "components/flexComponents/Content/typings";
import { inject } from "mobx-react";
import { ContentFactory } from "components/flexComponents/Content/factory/ContentFactory";

export const Content: React.FC<ContentProps> = inject(
  "routeStore",
  "analytics",
  "compositionStore"
)((props) => {
  const { flexComponent, compositionStore } = props;
  const pageHeading =
    compositionStore && compositionStore.composition ? compositionStore.composition.pageHeading : null;

  const contentComponent = ContentFactory.get({ ...flexComponent, ...{ pageHeading } });

  if (!contentComponent.shouldRender()) {
    return null;
  }

  return contentComponent.generate(props);
});

export default Content;
